import gql from 'graphql-tag';
import communityInfoFragment from '../community/communityInfo';
import communityMetaDataFragment from '../community/communityMetaData';

export default gql`
  fragment userCommunityConnection on User {
    communityConnection {
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          ...communityInfo
          ...communityMetaData
          contextPermissions {
            communityId
            isOwner
            isModerator
            reputation
            isExpert
            isChair
          }
        }
      }
    }
  }
  ${communityMetaDataFragment}
  ${communityInfoFragment}
`;
